import { useEffect, useState } from 'react';

const MicrophoneLevelIndicator = ({ deviceId }: { deviceId?: string }) => {
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (!deviceId) return;

    let audioContext: AudioContext | undefined;
    let analyser: AnalyserNode | undefined;
    let source: MediaStreamAudioSourceNode | undefined;
    let dataArray: Uint8Array | undefined;
    let animationFrameId: number;
    let stream: MediaStream | undefined;

    const initAudio = async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: { deviceId } });
        audioContext = new window.AudioContext();
        analyser = audioContext.createAnalyser();
        source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);
        analyser.fftSize = 32;
        const bufferLength = analyser.frequencyBinCount;
        dataArray = new Uint8Array(bufferLength);

        const update = () => {
          if (!analyser || !dataArray) return;
          analyser.getByteFrequencyData(dataArray);
          const avg = dataArray.reduce((a, b) => a + b, 0) / dataArray.length;
          const normalized = Math.min(10, Math.floor((avg / 256) * 10));
          setLevel(normalized);
          animationFrameId = requestAnimationFrame(update);
        };
        update();
      } catch (e) {
        console.error('Mic indicator error', e);
      }
    };
    initAudio();

    return () => {
      if (stream) stream.getTracks().forEach((t) => t.stop());
      if (audioContext) audioContext.close();
      cancelAnimationFrame(animationFrameId);
    };
  }, [deviceId]);

  return (
    <div className="flex gap-[2px] mt-1 w-full">
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} className={`h-[5px] w-full ${i < level ? 'bg-primary' : 'bg-line'} rounded-chip`} />
      ))}
    </div>
  );
};

export default MicrophoneLevelIndicator;
